const jobCardsArr = document.querySelectorAll('.job-card');

if (jobCardsArr.length) {
  jobCardsArr.forEach((jobCard) => {

    jobCard.addEventListener('mouseenter', () => {
      startJobCardHover(jobCard);
    });

    jobCard.addEventListener('mouseleave', () => {
      stopJobCardHover(jobCard);
    });

    jobCard.addEventListener('click', () => {
      if (window.innerWidth <= 1032 && !jobCard.closest('.swiper-slide')) {
        if (jobCard.classList.contains('is-hover')) {
          stopJobCardHover(jobCard);
        } else {
          startJobCardHover(jobCard);
        }
      }
    });

  });
}

window.startJobCardHover = function startJobCardHover(jobCard) {
  if (!jobCard) return;

  const textEl = jobCard.querySelector('.job-card__text');

  if (jobCard._hoverRemoveTimer) {
    clearTimeout(jobCard._hoverRemoveTimer);
  }

  jobCard.classList.add('is-hover');
  textEl?.classList.add('is-not-hovered');
}

window.stopJobCardHover = function stopJobCardHover(jobCard) {
  if (!jobCard) return;

  const textEl = jobCard.querySelector('.job-card__text');

  jobCard.classList.remove('is-hover');

  jobCard._hoverRemoveTimer = setTimeout(() => {
    textEl?.classList.remove('is-not-hovered');
  }, 400);
}